import { type AuthenticationResult, PublicClientApplication } from "@azure/msal-browser";

let pca: PublicClientApplication | null = null;

export async function initializeMicrosoftAuth(clientId: string) {
	if (pca) return;

	pca = new PublicClientApplication({
		auth: {
			clientId,
			authority: "https://login.microsoftonline.com/common",
			redirectUri: `${window.location.origin}/auth`,
		},
		cache: {
			cacheLocation: "sessionStorage",
		},
	});

	await pca.initialize();
}

export async function signInWithMicrosoftPopup(): Promise<string> {
	if (!pca) throw new Error("microsoft_auth_not_initialized");

	const result: AuthenticationResult = await pca.loginPopup({
		scopes: ["openid", "profile", "email", "User.Read"],
		prompt: "select_account",
	});

	if (!result.idToken) throw new Error("missing_id_token");

	return result.idToken;
}
